import { Page } from '@touche-lts/panel-ui/dist';
import { makeAutoObservable } from 'mobx';
import RootStore  from 'mobx-stores/root-store'
import { StatisticsHighlights, StoreAdminHighlightsDTO, StatisticsTableEntryDTO } from 'models/statistics';
import { Api, User} from 'services';
import moment from 'moment';
import { PeriodValue } from '@touche-lts/panel-ui/dist/components/shared/date-range-picker';

export class StatisticsStore {
  private rootStore:any
  private statisticsApi: Api['statisticsApi']

  constructor (rootStore:any) {
    this.rootStore = rootStore
    this.statisticsApi = this.rootStore.generalStore.api.statisticsApi
    makeAutoObservable(this);
  }

  // OBSERVABLES
  private highLights: StatisticsHighlights = null
  public storeAdminHighlights: StoreAdminHighlightsDTO = null
  private graphInfo: StatisticsTableEntryDTO[] = null
  private todayPeriod: string = moment().toISOString();
  private detaulfPeriod: string = moment().subtract(7,'d').toDate().toISOString();
  public endPeriod: string = moment().toISOString();
  public periodDate: string = moment().subtract(7,'d').toDate().toISOString();
  
  // ACTIONS
  public setHighlights = (highLights: StatisticsHighlights): void => {
    this.highLights = highLights
  }

  public setStoreAdminHighlights = (highlights: StoreAdminHighlightsDTO): void => {
    this.storeAdminHighlights = highlights
  }

  public setGraphInfo = (graphInfo: Page<StatisticsTableEntryDTO>): void => {
    this.graphInfo = graphInfo as any
  }

  public setPeriodDate = (dateISOString: string): void => {
    this.resetPeriods();
    this.periodDate = dateISOString;
    this.getGraphInfo();
  } 

  public setCustomPeriod = (period: PeriodValue) => {
    if(period) {
      this.periodDate = period.start.toISOString();
      this.endPeriod = period.end.toISOString();
    } else {
      this.resetPeriods();
    }
    this.getGraphInfo();
  }

  // COMPUTED
  public get statisticsHighlights (): StatisticsHighlights {
    return this.highLights
  }

  public get statisticsGraph (): StatisticsTableEntryDTO[] {
    return this.graphInfo
  }

  public get statiSticsGraphData () {
    const labels = this.graphInfo ? this.statisticsGraph.map(graphInfo => moment(graphInfo.date).format('DD.MM.YY')) : []
    return {
      labels,
      datasets: [
          {
            type: 'line' as const,
            label: 'Products sold',
            borderColor: '#B021D9',
            borderWidth: 2,
            fill: false,
            data: this.graphInfo ? this.statisticsGraph.map(graphInfo => graphInfo.sold) : [],
          },
          {
            type: 'bar' as const,
            label: 'Revenue',
            backgroundColor: '#3AABF2',
            data: this.graphInfo ? this.statisticsGraph.map(graphInfo => graphInfo.revenueToday) : [],
            borderColor: 'white',
            borderWidth: 2,
            }
      ],
    }
  }

  // METHODS
   private get assignedStoreId (): number | null {
    return JSON.parse(localStorage.getItem('UserStore'))?.assignedStore?.id ?? null
  }
 
  public getHighLights = async (): Promise<StatisticsHighlights | StoreAdminHighlightsDTO> => {
    const filterPayload = {
      dateEnd: this.endPeriod,
      dateStart: this.periodDate,
      storeIds:  this.assignedStoreId ? [this.assignedStoreId] : []
    }
    if (User.isStoreAdmin && this.assignedStoreId) {
      const highlights = await this.statisticsApi.getStoreAdminHighlights(
        this.assignedStoreId,
        filterPayload
      )
      if (!highlights) return
      this.setStoreAdminHighlights(highlights)
      return highlights
    }
    const statHighlights = await this.statisticsApi.getHighLights(filterPayload);
    if(!statHighlights) return
    this.setHighlights(statHighlights)
    return statHighlights
  }

  public getGraphInfo = async (): Promise<Page<StatisticsTableEntryDTO>> => {
    if (!this.assignedStoreId) return
    const filterPayload = {
      dateEnd: this.endPeriod,
      dateStart: this.periodDate,
      storeIds: this.assignedStoreId ? [this.assignedStoreId] : []
    }
    const statGraph = await this.statisticsApi.getStoreStatisticsGraph(filterPayload);
    if(!statGraph) return
    this.setGraphInfo(statGraph as any)
  }

  private resetPeriods = (): void => {
    this.periodDate = JSON.parse(JSON.stringify(this.detaulfPeriod));
    this.endPeriod = JSON.parse(JSON.stringify(this.todayPeriod));
  }

}
